'use strict';
(() => {
  const node=document.getElementById('in-store-config');if(!node)return;
  const config=JSON.parse(node.textContent),ui=config.ui,$=s=>document.querySelector(s),t=k=>ui[k]||k;
  const inputRoot=document.documentElement;
  const setInputModality=mode=>{if(inputRoot.dataset.inInputModality!==mode)inputRoot.dataset.inInputModality=mode;};
  document.addEventListener('pointerdown',()=>setInputModality('pointer'),{capture:true,passive:true});
  document.addEventListener('touchstart',()=>setInputModality('pointer'),{capture:true,passive:true});
  document.addEventListener('keydown',event=>{if(!event.metaKey&&!event.altKey&&!event.ctrlKey)setInputModality('keyboard');},true);
  const esc=s=>String(s??'').replace(/[&<>"']/g,c=>({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
  const money=n=>new Intl.NumberFormat(config.locale||'en',{style:'currency',currency:config.currency||'USD'}).format(n);
  function syncProductPrice(root,selected){
    const block=root.querySelector('[data-in-price-block]');
    const price=root.querySelector('[data-in-price]');
    const compare=root.querySelector('[data-in-compare]');
    const savings=root.querySelector('[data-in-sale-savings]');
    const badge=root.querySelector('[data-in-sale-badge]');
    const priceValue=Number(selected.priceCents),compareValue=Number(selected.compareCents);
    const validPrice=selected.priceCents!==null&&selected.priceCents!==undefined&&Number.isFinite(priceValue)&&priceValue>=0;
    const validCompare=selected.compareCents!==null&&selected.compareCents!==undefined&&Number.isFinite(compareValue)&&compareValue>0;
    const onSale=!!block&&block.dataset.saleEnabled!=='false'&&selected.discounted===true&&validPrice&&validCompare&&compareValue>priceValue;
    if(price){price.textContent=selected.price||'';if(price.dataset?.priceLabel)price.setAttribute('aria-label',`${price.dataset.priceLabel}: ${selected.price||''}`);}
    if(compare){compare.textContent=onSale?selected.compare||'':'';compare.hidden=!onSale;if(compare.dataset?.priceLabel)compare.setAttribute('aria-label',onSale?`${compare.dataset.priceLabel}: ${selected.compare||''}`:compare.dataset.priceLabel);}
    if(badge){badge.textContent=onSale?selected.badgeText||'':'';badge.hidden=!onSale||!badge.textContent;}
    if(savings){savings.textContent=onSale?selected.savingsText||'':'';savings.hidden=!onSale||block.dataset.showSavings==='false'||!savings.textContent;}
    block?.classList.toggle('is-on-sale',onSale);
  }
  function cartImageUrl(source){
    try{
      const url=new URL(source,location.origin);
      if(['https:','http:'].includes(url.protocol)&&(url.hostname==='cdn.shopify.com'||url.origin===location.origin&&url.pathname.startsWith('/cdn/shop/')))url.searchParams.set('width','240');
      return url.href;
    }catch{return source;}
  }
  let modal=$('#InModal'),toastTimer,cartCelebration=null,shippingUnlockTimer=0,shippingUnlockKey=null;
  const cartViewRequests=createCartViewRequests();
  let cartMutationPending=null;
  const shippingProgressAnimations=new Set();
  const boundModals=new WeakSet();
  function bindModal(){
    if(modal!==$('#InModal')){cartViewRequests.cancel();stopCartCelebration();stopShippingProgressMotion();if(modal)window.IdolnestDrawerMotion?.dispose(modal);}
    modal=$('#InModal');
    if(!modal||boundModals.has(modal))return;
    boundModals.add(modal);
    const host=modal;
    modal.addEventListener('close',()=>{if(host!==modal||host.open)return;cartViewRequests.cancel();const anotherDialog=document.querySelector('dialog[open]');if(!anotherDialog)document.body.style.overflow='';stopCartCelebration();stopShippingProgressMotion();if(!anotherDialog&&host.classList.contains('drawer')&&$('[data-in-cart-page]')&&!window.Shopify?.designMode)requestAnimationFrame(()=>{if(!document.querySelector('dialog[open]')&&$('[data-in-cart-page]')&&!window.Shopify?.designMode)location.replace(config.root);});});
    modal.addEventListener('idolnest:drawer:closing',()=>{if(host!==modal)return;cartViewRequests.cancel();stopCartCelebration();stopShippingProgressMotion();});
    modal.addEventListener('click',e=>{if(e.target===modal){const r=modal.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)closeModal();}});
  }
  bindModal();
  const notify=message=>{const el=$('#toast');el.textContent=message;el.classList.add('visible');clearTimeout(toastTimer);toastTimer=setTimeout(()=>el.classList.remove('visible'),3500);};
  function openModal(html,kind=''){bindModal();if(kind!=='drawer'){cartViewRequests.cancel();stopCartCelebration();stopShippingProgressMotion();window.IdolnestDrawerMotion?.dispose(modal);modal.removeAttribute('aria-busy');delete modal.dataset.inCartState;}modal.className='modal in-modal '+kind;$('#InModalContent').innerHTML=html;if(kind==='drawer')modal.setAttribute('aria-labelledby','InCartTitle');else modal.removeAttribute('aria-labelledby');if(kind==='drawer'&&window.IdolnestDrawerMotion)window.IdolnestDrawerMotion.open(modal,'right');else if(!modal.open)modal.showModal();document.body.style.overflow='hidden';}
  function closeModal(immediate=false){bindModal();cartViewRequests.cancel();if(modal.classList.contains('drawer')&&window.IdolnestDrawerMotion)return window.IdolnestDrawerMotion.close(modal,immediate);modal.close();if(!document.querySelector('dialog[open]'))document.body.style.overflow='';}
  function createCartViewRequests(){
    let version=0,controller=null;
    return {
      begin(){controller?.abort();controller=new AbortController();return {version:++version,signal:controller.signal};},
      current(ticket){return !!ticket&&ticket.version===version&&!ticket.signal.aborted;},
      cancel(){version++;controller?.abort();controller=null;},
      get version(){return version;}
    };
  }
  function cartText(key){try{return JSON.parse($('#in-cart-loading-copy')?.textContent||'{}')[key]||t('error');}catch{return t('error');}}
  async function boundedFetch(url,options={},timeoutMs=12000,consume=response=>response){
    const controller=new AbortController(),external=options.signal;
    let timedOut=false;
    const abort=()=>controller.abort();
    if(external?.aborted)controller.abort();else external?.addEventListener('abort',abort,{once:true});
    const timer=setTimeout(()=>{timedOut=true;controller.abort();},timeoutMs);
    try{return await consume(await fetch(url,{...options,signal:controller.signal}));}
    catch(error){if(timedOut)throw new Error(cartText('timeout'));throw error;}
    finally{clearTimeout(timer);external?.removeEventListener('abort',abort);}
  }
  async function request(path,body,options={}){return boundedFetch(config.root.replace(/\/$/,'')+'/'+path,{method:body?'POST':'GET',credentials:'same-origin',signal:options.signal,headers:body instanceof FormData?{'Accept':'application/json'}:body?{'Content-Type':'application/json','Accept':'application/json'}:{'Accept':'application/json'},body:body instanceof FormData?body:body?JSON.stringify(body):undefined},12000,async response=>{const data=await response.json();if(!response.ok)throw new Error(data.description||data.message||t('error'));return data;});}
  const inventoryByVariant=new Map();
  const cartQuantities=new Map();
  const productInstances=new Map();
  let cartBusy=false,cartRevision=0;
  function quantityBounds(variant,inCart=0){
    const min=Math.max(1,Math.trunc(Number(variant?.min)||1));
    const step=Math.max(1,Math.trunc(Number(variant?.step)||1));
    let max=variant?.max==null?Infinity:Math.max(0,Number(variant.max)-inCart);
    if(variant?.inventoryTracked&&variant.inventoryPolicy!=='continue'&&Number.isFinite(variant.inventoryQuantity))max=Math.min(max,Math.max(0,variant.inventoryQuantity-inCart));
    if(!variant?.available)max=0;
    if(Number.isFinite(max)&&max>=min)max=min+Math.floor((max-min)/step)*step;
    return {min,step,max,canPurchase:max>=min};
  }
  function boundedQuantity(value,bounds){
    if(!bounds.canPurchase)return 0;
    const number=Number(value);
    const whole=Number.isFinite(number)?Math.floor(number):bounds.min;
    return Math.min(bounds.max,bounds.min+Math.floor(Math.max(0,whole-bounds.min)/bounds.step)*bounds.step);
  }
  const quantityMessage=count=>t('quantity_limit').replace('__COUNT__',String(Math.max(0,count)));
  function setCartQuantities(items){
    cartQuantities.clear();
    for(const item of items||[]){const id=String(item.variant_id??item.id);cartQuantities.set(id,(cartQuantities.get(id)||0)+Number(item.quantity||0));}
    for(const instance of productInstances.values())instance.updateQuantity();
  }
  function updateCart(cart){
    cartRevision++;
    const el=$('#cart-count');if(el)el.textContent=cart.item_count;
    setCartQuantities(cart.items);
    observeCartCelebration(cart);
    return cart;
  }
  function applyInventory(data){
    for(const variant of data.variants)inventoryByVariant.set(String(variant.id),variant);
    document.dispatchEvent(new CustomEvent('idolnest:inventory:updated',{detail:{productId:data.id,variants:data.variants}}));
  }
  async function readInventory(path,options={}){
    const url=new URL(path,location.origin);
    url.hash='';
    url.searchParams.set('section_id','idolnest-inventory');
    url.searchParams.set('_stock',String(Date.now()));
    const preview=new URL(location.href).searchParams.get('preview_theme_id');
    if(preview)url.searchParams.set('preview_theme_id',preview);
      const text=await boundedFetch(url,{credentials:'same-origin',cache:'no-store',signal:options.signal,headers:{Accept:'text/html'}},10000,async response=>{if(!response.ok)throw new Error(t('stock_check_failed'));return response.text();});
      const html=new DOMParser().parseFromString(text,'text/html');
      const inventory=html.querySelector('[data-in-inventory-json]');
      const data=inventory?JSON.parse(inventory.textContent):null;
      if(!data?.id||!Array.isArray(data.variants)||!Array.isArray(data.cartItems))throw new Error(t('stock_check_failed'));
      return data;
  }
  async function fetchCart(){return updateCart(await request('cart.js'));}
  async function refreshCartInventory(cart,options={}){
    const paths=[...new Set(cart.items.map(item=>item.url.split('?')[0]))];
    const results=await Promise.allSettled(paths.map(async path=>{const data=await readInventory(path,options);if(!options.current||options.current())applyInventory(data);}));
    if(results.some(result=>result.status==='rejected'))throw new Error(t('stock_check_failed'));
    if((!options.current||options.current())&&cart.items.some(item=>!inventoryByVariant.has(String(item.variant_id))))throw new Error(t('stock_check_failed'));
  }
  function cartLineBounds(item){
    const variant=inventoryByVariant.get(String(item.variant_id));
    if(!variant)return null;
    return quantityBounds(variant,Math.max(0,(cartQuantities.get(String(item.variant_id))||0)-item.quantity));
  }
  // Persist only a cart fingerprint, never the cart token or its secret query string.
  function cartCelebrationId(token){
    let hash=2166136261;
    for(const character of String(token||'cart').split('?')[0])hash=Math.imul(hash^character.charCodeAt(0),16777619);
    return (hash>>>0).toString(36);
  }
  function createCartCelebrationLedger(getStorage){
    const memory=new Set(),storageKey='idolnest.shipping.celebrations.v1';
    function saved(){try{const value=JSON.parse(getStorage().getItem(storageKey)||'[]');return Array.isArray(value)?value.filter(key=>typeof key==='string').slice(-16):[];}catch{return [];}}
    function write(keys){try{getStorage().setItem(storageKey,JSON.stringify(keys.slice(-16)));}catch{/* Memory still prevents repeats when storage is unavailable. */}}
    return {
      has(key){return memory.has(key)||saved().includes(key);},
      mark(key){memory.add(key);write([...new Set([...saved(),...memory])]);},
      clear(key){memory.delete(key);write(saved().filter(item=>item!==key));},
      resetCart(cartId){const prefix=cartId+':';for(const key of memory)if(key.startsWith(prefix))memory.delete(key);write(saved().filter(key=>!key.startsWith(prefix)));}
    };
  }
  function createShippingCelebrationState(ledger){
    let previous=null,pending=null;
    return {
      observe(cartId,key,state,empty,enabled){
        if(empty){
          if(previous?.cartId)ledger.resetCart(previous.cartId);
          ledger.resetCart(cartId);previous={cartId,key,empty:true,eligible:false,complete:false};pending=null;return true;
        }
        if(previous?.key!==key)pending=null;
        if(state&&!state.complete&&ledger.has(key))ledger.clear(key);
        if(enabled&&state?.complete&&!ledger.has(key))pending=key;
        if(!enabled||!state?.complete)pending=null;
        previous={cartId,key,empty:false,eligible:!!state,complete:!!state?.complete};
        return !enabled||!state?.complete;
      },
      take(key){if(pending!==key)return false;pending=null;if(ledger.has(key))return false;ledger.mark(key);return true;}
    };
  }
  const shippingCelebration=createShippingCelebrationState(createCartCelebrationLedger(()=>window.localStorage));
  const reducedCartMotion=window.matchMedia('(prefers-reduced-motion: reduce)');
  function readShippingRule(){try{return JSON.parse($('#in-free-shipping-config')?.textContent||'null');}catch{return null;}}
  function celebrationCartKey(cart,rule,state){return [cartCelebrationId(cart.token),String(cart.currency||config.currency).toUpperCase(),state?.threshold||Math.round(Number(rule?.threshold)*100)].join(':');}
  function observeCartCelebration(cart){
    const rule=readShippingRule(),state=freeShippingState(cart,rule,{currency:config.currency});
    if(shippingCelebration.observe(cartCelebrationId(cart.token),celebrationCartKey(cart,rule,state),state,!cart.item_count,!!(rule?.celebration?.enabled||rule?.motion?.enabled))){
      stopCartCelebration();
      if(!state||!rule?.motion?.enabled||shippingUnlockKey)stopShippingProgressMotion();
    }
  }
  function stopCartCelebration(finished=false){
    if(!cartCelebration)return;
    const active=cartCelebration;cartCelebration=null;
    cancelAnimationFrame(active.frame);clearTimeout(active.timeout);active.canvas.remove();
    active.host.dataset.inCelebrationState=finished?'finished':'cancelled';
    active.host.dataset.inCelebrationEnded=String(Date.now());
  }
  // Pure canvas engine. Duration accepts seconds (1..5) or milliseconds (1000..5000).
  // The returned scene is immutable during playback; drawConfettiFrame returns false at the end.
  function createConfettiScene(options = {}, random = Math.random) {
    const finite = (value, fallback) => Number.isFinite(Number(value)) ? Number(value) : fallback;
    const clamp = (value, min, max) => Math.max(min, Math.min(max, value));
    const next = () => clamp(finite(random(), 0.5), 0, 1);
    const width = clamp(finite(options.width, 390), 1, 4096);
    const height = clamp(finite(options.height, 844), 1, 4096);
    const rawDuration = finite(options.duration, 3);
    const duration = clamp(rawDuration > 10 ? rawDuration : rawDuration * 1000, 1000, 5000);
    const requestedCount = clamp(Math.round(finite(options.count, 48)), 24, 120);
    const count = Math.min(160, requestedCount * 2);
    const colors = (Array.isArray(options.colors) ? options.colors : [])
      .filter(color => typeof color === 'string' && /^#[0-9a-f]{6}$/i.test(color)).slice(0, 6);
    if (!colors.length) colors.push('#E16FAF', '#FFFFFF', '#E7C46A');
    const scale = clamp(Math.min(width / 390, height / 620), 0.2, 1.25);
    const verticalScale = clamp(height / 760, 0.18, 1.35);
    const originY = clamp(finite(options.originY, height * 0.76), 0, height);
    const firstBurstCount = Math.round(count * 0.72);
    const particles = Array.from({length: count}, (_, index) => {
      const burst = index >= firstBurstCount ? 1 : 0;
      const side = index % 2 === 0 ? 1 : -1;
      const layer = index % 3;
      const depth = [0.72, 0.95, 1.2][layer];
      const type = index % 13 === 0 ? 'star' : index % 7 === 0 ? 'curl' : index % 5 === 0 ? 'ribbon' : 'foil';
      const strength = burst ? 0.76 : 1;
      const size = (type === 'star' ? 8 + next() * 5 : 5 + next() * 5) * scale * depth;
      return {
        burst, side, layer, type,
        color: colors[index % colors.length],
        x: width * (side === 1 ? (burst ? 0.17 : 0.065) : (burst ? 0.83 : 0.935)),
        y: clamp(originY + (next() - 0.5) * 20 * scale + burst * 10 * scale, 0, height),
        vx: side * width * (0.17 + next() * 0.69) * strength,
        vy: -(350 + next() * 240) * verticalScale * strength,
        gravity: (270 + next() * 110) * verticalScale,
        drag: 1.05 + next() * 0.7,
        delay: (burst ? 0.25 : 0) + next() * (burst ? 0.09 : 0.065),
        rotation: (next() - 0.5) * Math.PI,
        spin: (next() - 0.5) * (type === 'foil' ? 8 : 3.4),
        phase: next() * Math.PI * 2,
        flutter: (5 + next() * 11) * scale,
        frequency: 2 + next() * 2,
        opacity: [0.66, 0.9, 1][layer],
        size,
        length: (type === 'curl' ? 62 + next() * 35 : type === 'ribbon' ? 38 + next() * 32 : 10 + next() * 10) * scale * depth,
        bend: (type === 'curl' ? 9 + next() * 7 : 5 + next() * 5) * scale * depth,
        waves: type === 'curl' ? 2.2 + next() * 0.8 : 1.05 + next() * 0.5
      };
    }).sort((a, b) => a.layer - b.layer);
    return {width, height, duration, count, colors, particles};
  }
  
  function drawConfettiFrame(ctx, scene, elapsedMs) {
    if (!ctx || !scene || !Number.isFinite(elapsedMs) || elapsedMs < 0 || elapsedMs >= scene.duration) return false;
    const timeline = elapsedMs / scene.duration * 3;
    const tail = Math.max(0, Math.min(1, (1 - elapsedMs / scene.duration) / 0.26));
    const tailFade = tail * tail * (3 - 2 * tail);
    ctx.clearRect(0, 0, scene.width, scene.height);
    for (const particle of scene.particles) {
      const age = timeline - particle.delay;
      if (age <= 0) continue;
      // Analytic drag and gravity avoid frame-rate-dependent drift or stored trails.
      const travel = (1 - Math.exp(-particle.drag * age)) / particle.drag;
      const flutterIn = Math.min(1, age * 4);
      const x = particle.x + particle.vx * travel + Math.sin(age * particle.frequency + particle.phase) * particle.flutter * flutterIn;
      const y = particle.y + particle.vy * age + particle.gravity * age * age * 0.5;
      const margin = particle.length + particle.size * 2;
      if (x < -margin || x > scene.width + margin || y < -margin || y > scene.height + margin) continue;
      const fadeIn = Math.min(1, age / 0.075);
      const alpha = particle.opacity * fadeIn * tailFade;
      if (alpha <= 0) continue;
      const angle = particle.rotation + particle.spin * age + Math.sin(age * 2 + particle.phase) * 0.12;
      const face = 0.4 + Math.abs(Math.cos(age * 3.2 + particle.phase)) * 0.6;
      ctx.save();
      ctx.translate(x, y);
      ctx.rotate(angle);
      ctx.globalAlpha = alpha;
      ctx.fillStyle = particle.color;
      if (particle.type === 'ribbon' || particle.type === 'curl') {
        // A filled, tapered S-shaped strip reads as silk rather than a line or square.
        const steps = particle.type === 'curl' ? 20 : 14;
        const stripWidth = particle.size * (particle.type === 'curl' ? 0.44 : 0.64);
        const center = u => Math.sin(u * particle.waves * Math.PI * 2 + particle.phase + age * 2.6) * particle.bend * (0.28 + u * 0.72);
        const halfWidth = u => stripWidth * (0.45 + Math.abs(Math.sin(u * Math.PI * 1.5 + age * 2.1 + particle.phase)) * 0.55) / 2;
        ctx.beginPath();
        for (let i = 0; i <= steps; i++) {
          const u = i / steps, px = center(u) - halfWidth(u), py = u * particle.length;
          if (i === 0) ctx.moveTo(px, py); else ctx.lineTo(px, py);
        }
        for (let i = steps; i >= 0; i--) {
          const u = i / steps;
          ctx.lineTo(center(u) + halfWidth(u), u * particle.length);
        }
        ctx.closePath();
        ctx.fill();
        ctx.beginPath();
        for (let i = 0; i <= steps; i++) {
          const u = i / steps, px = center(u) - halfWidth(u) * 0.34, py = u * particle.length;
          if (i === 0) ctx.moveTo(px, py); else ctx.lineTo(px, py);
        }
        ctx.globalAlpha = alpha * 0.38;
        ctx.strokeStyle = '#FFFFFF';
        ctx.lineWidth = Math.max(0.45, stripWidth * 0.18);
        ctx.lineCap = 'round';
        ctx.stroke();
      } else if (particle.type === 'star') {
        ctx.scale(0.85 + face * 0.15, 1);
        ctx.beginPath();
        for (let point = 0; point < 8; point++) {
          const theta = point * Math.PI / 4, radius = particle.size * (point % 2 ? 0.24 : 1);
          const px = Math.cos(theta) * radius, py = Math.sin(theta) * radius;
          if (point === 0) ctx.moveTo(px, py); else ctx.lineTo(px, py);
        }
        ctx.closePath();
        ctx.fill();
        ctx.globalAlpha = alpha * 0.25;
        ctx.fillStyle = '#FFFFFF';
        ctx.fillRect(-particle.size * 0.055, -particle.size * 0.65, particle.size * 0.11, particle.size * 1.3);
      } else {
        // A constant edge highlight makes the foil dimensional without flashing.
        ctx.scale(face, 1);
        ctx.fillRect(-particle.size / 2, -particle.length / 2, particle.size, particle.length);
        ctx.globalAlpha = alpha * 0.33;
        ctx.fillStyle = '#FFFFFF';
        ctx.fillRect(-particle.size / 2, -particle.length / 2, particle.size * 0.2, particle.length);
        ctx.globalAlpha = alpha * 0.13;
        ctx.fillStyle = '#3A283D';
        ctx.fillRect(particle.size * 0.29, -particle.length / 2, particle.size * 0.21, particle.length);
      }
      ctx.restore();
    }
    return true;
  }
  function playCartCelebration(options){
    if(reducedCartMotion.matches||document.hidden||!modal?.open)return;
    stopCartCelebration();
    const host=modal,rect=host.getBoundingClientRect(),progress=host.querySelector('[data-in-shipping-progress]');
    if(!progress||rect.width<=0||rect.height<=0)return;
    const canvas=document.createElement('canvas'),ctx=canvas.getContext('2d');if(!ctx)return;
    canvas.className='in-cart-confetti';canvas.setAttribute('aria-hidden','true');
    const width=rect.width,height=rect.height,dpr=Math.min(window.devicePixelRatio||1,2);
    canvas.width=Math.round(width*dpr);canvas.height=Math.round(height*dpr);ctx.scale(dpr,dpr);
    const duration=Math.min(5,Math.max(1,Number(options.duration)||3))*1000;
    const count=Math.min(120,Math.max(24,Math.round(Number(options.count)||48)));
    const colors=(Array.isArray(options.colors)?options.colors:[]).filter(color=>/^#[0-9a-f]{6}$/i.test(color));
    if(!colors.length)colors.push('#E16FAF','#FFFFFF','#E7C46A');
    const originY=Math.min(height-120,Math.max(150,progress.getBoundingClientRect().top-rect.top+25));
    const scene=createConfettiScene({width,height,originY,count,colors,duration});
    host.append(canvas);
    host.dataset.inCelebrationCount=String(Number(host.dataset.inCelebrationCount||0)+1);
    host.dataset.inCelebrationState='playing';host.dataset.inCelebrationStarted=String(Date.now());
    host.dataset.inCelebrationDuration=String(duration);
    const active={canvas,host,frame:0,timeout:0};cartCelebration=active;
    const start=performance.now();
    function draw(now){
      if(cartCelebration!==active)return;
      if(!host.open||!host.isConnected||reducedCartMotion.matches||document.hidden){stopCartCelebration();return;}
      const elapsed=now-start;if(elapsed>=duration){stopCartCelebration(true);return;}
      drawConfettiFrame(ctx,scene,elapsed);
      active.frame=requestAnimationFrame(draw);
    }
    active.frame=requestAnimationFrame(draw);active.timeout=setTimeout(()=>stopCartCelebration(true),duration+80);
  }
  function stopShippingProgressMotion(){
    clearTimeout(shippingUnlockTimer);shippingUnlockTimer=0;shippingUnlockKey=null;
    for(const animation of shippingProgressAnimations)animation.cancel();shippingProgressAnimations.clear();
    modal?.querySelector('.is-unlocking')?.classList.remove('is-unlocking');
  }
  function shippingProgressSnapshot(){
    if(!modal?.open||!modal.classList.contains('drawer'))return null;
    const progress=modal.querySelector('[data-in-shipping-progress]'),fill=progress?.querySelector('.in-shipping-fill'),track=progress?.querySelector('.in-shipping-track');
    if(!fill||!track)return null;
    const width=track.getBoundingClientRect().width;
    return {key:progress.dataset.inShippingKey,percent:width?Math.min(100,Math.max(0,fill.getBoundingClientRect().width/width*100)):0};
  }
  function animateCartProgress(previous,rule,state,key,celebrate){
    const progress=modal?.querySelector('[data-in-shipping-progress]');
    if(!progress||!state||reducedCartMotion.matches||document.hidden)return;
    const enabled=!!rule.motion?.enabled,duration=enabled?Math.min(1500,Math.max(300,Number(rule.motion.duration)||900)):0;
    const from=previous?.key===key?previous.percent:state.complete?100:0;
    const changed=Math.abs(from-state.percent)>.05;
    if(enabled&&changed){
      const animation=progress.querySelector('.in-shipping-fill').animate([{width:from+'%'},{width:state.percent+'%'}],{duration,easing:'cubic-bezier(.22,1,.36,1)'});
      shippingProgressAnimations.add(animation);animation.onfinish=()=>shippingProgressAnimations.delete(animation);
      modal.dataset.inProgressFrom=from.toFixed(2);modal.dataset.inProgressTo=state.percent.toFixed(2);modal.dataset.inProgressDuration=String(duration);
      if(previous){const message=progress.querySelector('.in-shipping-message').animate([{opacity:.5,transform:'translateY(3px)'},{opacity:1,transform:'translateY(0)'}],{duration:Math.min(duration,500),easing:'ease-out'});shippingProgressAnimations.add(message);message.onfinish=()=>shippingProgressAnimations.delete(message);}
    }
    if(!celebrate||!state.complete)return;
    shippingUnlockKey=key;
    const unlock=()=>{
      shippingUnlockKey=null;shippingUnlockTimer=0;
      if(!modal?.open||!progress.isConnected||!progress.classList.contains('is-complete')||document.hidden||reducedCartMotion.matches)return;
      if(enabled){progress.classList.add('is-unlocking');modal.dataset.inUnlockCount=String(Number(modal.dataset.inUnlockCount||0)+1);}
      if(rule.celebration?.enabled)playCartCelebration(rule.celebration);
    };
    if(enabled&&changed)shippingUnlockTimer=setTimeout(unlock,Math.round(duration*.58));else unlock();
  }
  function openCart(cart,reveal=true){
    if(!reveal&&(!modal?.open||!modal.classList.contains('drawer')||window.IdolnestDrawerMotion?.isClosing(modal))){updateCart(cart);return false;}
    const previous=shippingProgressSnapshot(),queuedKey=shippingUnlockKey;
    stopShippingProgressMotion();
    openModal(cartHtml(cart),'drawer');
    modal.dataset.inCartState='ready';modal.removeAttribute('aria-busy');
    const rule=readShippingRule(),state=freeShippingState(cart,rule,{currency:config.currency}),key=celebrationCartKey(cart,rule,state);
    const celebrate=shippingCelebration.take(key)||queuedKey===key;
    animateCartProgress(previous,rule,state,key,celebrate);
    return true;
  }
  document.addEventListener('visibilitychange',()=>{if(document.hidden){stopCartCelebration();stopShippingProgressMotion();}});
  window.addEventListener('pagehide',()=>{stopCartCelebration();stopShippingProgressMotion();});
  window.addEventListener('resize',()=>{stopCartCelebration();stopShippingProgressMotion();});
  reducedCartMotion.addEventListener('change',()=>{if(reducedCartMotion.matches){stopCartCelebration();stopShippingProgressMotion();}});
  function freeShippingState(cart,rule,context){
    if(!rule?.enabled||!cart?.item_count||cart.requires_shipping===false)return null;
    const currency=String(cart.currency||context.currency||'').trim().toUpperCase();
    if(currency!==String(rule.currency||'USD').trim().toUpperCase())return null;
    const countries=String(rule.countries||'').toUpperCase().split(/[\s,，;；]+/).filter(Boolean);
    if(countries.length&&!countries.includes(String(rule.country||context.country||'').toUpperCase()))return null;
    const threshold=Math.round(Number(rule.threshold)*100);
    if(!Number.isSafeInteger(threshold)||threshold<=0)return null;
    const basis=['total_price','original_total_price'].includes(rule.basis)?rule.basis:'total_price';
    const subtotal=Number(cart[basis]);
    if(!Number.isSafeInteger(subtotal)||subtotal<0)return null;
    return {threshold,subtotal,remaining:Math.max(0,threshold-subtotal),percent:Math.min(100,subtotal/threshold*100),complete:subtotal>=threshold};
  }
  function cartShippingProgress(cart){
    const rule=readShippingRule();
    const state=freeShippingState(cart,rule,{currency:config.currency});
    if(!state)return '';
    const amount=money(state.remaining/100),threshold=money(state.threshold/100);
    const currency=String(rule.currency||'USD').toUpperCase();
    const target=rule.compactTarget?(currency==='USD'?'US$':currency+' ')+new Intl.NumberFormat(config.locale||'en',{minimumFractionDigits:0,maximumFractionDigits:2}).format(state.threshold/100):threshold;
    const rate=Number(rule.rateNote?.amount);
    const policyAmount=(currency==='USD'?'US$':currency+' ')+new Intl.NumberFormat(config.locale||'en',{minimumFractionDigits:0,maximumFractionDigits:2}).format(rate);
    const policyText=rule.rateNote?.enabled&&Number.isFinite(rate)&&rate>=0?String(rule.rateNote.text||'').replaceAll('{rate}',policyAmount).replaceAll('{threshold}',target):'';
    const policyHtml=policyText?`<p class="in-shipping-rate-note">${esc(policyText)}</p>`:'';
    const headingColor=/^#[0-9a-f]{6}$/i.test(rule.headingColor||'')?rule.headingColor:'#D8B65F';
    const sheenDuration=Math.min(6,Math.max(2,Number(rule.motion?.shimmerDuration)||3));
    const glowStrength=Math.min(1,Math.max(.2,(Number(rule.motion?.glowStrength)||70)/100));
    const text=String(state.complete?rule.complete:rule.pending).replaceAll('{amount}',amount).replaceAll('{threshold}',threshold);
    const truck='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 5h11v12H3zM14 9h4l3 4v4h-7M3 17h2m4 0h7m4 0h1"/><circle cx="7" cy="17" r="2"/><circle cx="18" cy="17" r="2"/></svg>';
    const star='<svg viewBox="0 0 20 20" fill="currentColor" aria-hidden="true"><path d="M10 0C11.2 7.3 12.7 8.8 20 10C12.7 11.2 11.2 12.7 10 20C8.8 12.7 7.3 11.2 0 10C7.3 8.8 8.8 7.3 10 0Z"/></svg>';
    return `<section class="in-shipping-progress${state.complete?' is-complete':''}${rule.motion?.enabled&&rule.motion.shimmer?' has-shimmer':''}${rule.motion?.enabled&&rule.motion.borderGlow?' has-border-glow':''}" style="--in-shipping-heading:${headingColor};--in-shipping-sheen-duration:${sheenDuration}s;--in-shipping-glow-strength:${glowStrength}" data-in-shipping-progress data-in-shipping-key="${esc(celebrationCartKey(cart,rule,state))}"><div class="in-shipping-stars" aria-hidden="true">${star.repeat(3)}</div><div class="in-shipping-heading"><span class="in-shipping-icon">${truck}</span><span>${esc(rule.title)}</span><span class="in-shipping-target">${esc(target)}</span></div><p class="in-shipping-message" role="status" aria-live="polite" aria-atomic="true">${esc(text)}</p><div class="in-shipping-track" role="progressbar" aria-label="${esc(rule.label)}" aria-valuemin="0" aria-valuemax="100" aria-valuenow="${state.percent.toFixed(2)}" aria-valuetext="${esc(text)}"><span class="in-shipping-fill" style="width:${state.percent.toFixed(2)}%"></span></div>${policyHtml}</section>`;
  }
  function cartFallbackUrl(){const url=new URL(config.cart,location.origin);url.searchParams.set('cart_view','page');const preview=new URL(location.href).searchParams.get('preview_theme_id');if(preview)url.searchParams.set('preview_theme_id',preview);return url.pathname+url.search;}
  function cartHeaderHtml(count,status=''){
    const bagIcon='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 7h14l1 14H4L5 7Z"/><path d="M8 7V5a4 4 0 0 1 8 0v2M9 11a3 3 0 0 0 6 0"/></svg>';
    return `<header class="in-cart-header"><div class="in-cart-heading"><h2 id="InCartTitle"><span class="in-cart-bag-icon">${bagIcon}</span><span>${esc(t('your_bag'))}</span>${count==null?'':`<span class="in-cart-count">${count}</span>`}</h2><p class="in-cart-status" data-in-cart-status role="status" aria-live="polite">${esc(status)}</p></div></header>`;
  }
  function cartFailureHtml(message){return `<div class="in-cart-load-error" role="alert"><p>${esc(message)}</p><div><button type="button" data-in-cart-retry>${esc(cartText('retry'))}</button><a href="${esc(cartFallbackUrl())}">${esc(cartText('view_cart'))}</a></div></div>`;}
  function cartLoadingHtml(error=''){
    const skeleton='<div class="in-cart-skeleton-card"><span class="in-cart-skeleton-image"></span><span class="in-cart-skeleton-copy"><i></i><i></i><i></i></span></div>';
    return `<div class="in-cart-shell is-loading">${cartHeaderHtml(null,error?'':cartText('loading'))}<div class="in-cart-items" data-in-cart-scroll>${error?`<div class="in-cart-error-state"><span aria-hidden="true">✦</span><h3>${esc(cartText('error_title'))}</h3>${cartFailureHtml(error)}</div>`:`<div class="in-cart-skeleton" aria-hidden="true">${skeleton.repeat(2)}</div>`}</div>${error?'':`<footer class="in-cart-footer in-cart-loading-footer"><div class="in-cart-skeleton-total" aria-hidden="true"></div><div class="in-cart-skeleton-checkout" aria-hidden="true"></div><a class="in-cart-native-link" href="${esc(cartFallbackUrl())}">${esc(cartText('view_cart'))}</a></footer>`}</div>`;
  }
  function cartHtml(cart,mode='ready',message=''){
    updateCart(cart);
    const pending=mode!=='ready',disabled=pending?'disabled':'';
    const needsAdjustment=!pending&&cart.items.some(item=>{const bounds=cartLineBounds(item);return !bounds||!bounds.canPurchase||item.quantity<bounds.min||item.quantity>bounds.max||(item.quantity-bounds.min)%bounds.step!==0;});
    if(needsAdjustment&&!message)message=cartText('stock_changed');
    const removeIcon='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M4 7h16M9 7V4h6v3M6 7l1 14h10l1-14M10 11v6M14 11v6"/></svg>';
    const lines=cart.items.map(item=>{const bounds=cartLineBounds(item);return `<article class="in-cart-item" data-in-cart-line="${esc(item.key)}">
      <a class="in-cart-image" href="${esc(item.url)}">${item.image?`<img src="${esc(cartImageUrl(item.image))}" alt="${esc(item.product_title)}" width="88" height="88">`:'<span aria-hidden="true">◇</span>'}</a>
      <div class="in-cart-info"><h3><a href="${esc(item.url)}">${esc(item.product_title)}</a></h3>
        ${item.variant_title&&item.variant_title!=='Default Title'?`<p class="in-cart-variant">${esc(item.variant_title)}</p>`:''}
        <div class="in-cart-item-bottom">
          <div class="in-cart-quantity" role="group" aria-label="${esc(t('quantity'))}: ${esc(item.product_title)}"><button type="button" data-in-cart-key="${esc(item.key)}" data-in-cart-qty="${Math.max(0,item.quantity-(bounds?.step||1))}" ${disabled} aria-label="${esc(t('decrease'))}: ${esc(item.product_title)}">−</button><span>${item.quantity}</span><button type="button" data-in-cart-key="${esc(item.key)}" data-in-cart-qty="${item.quantity+(bounds?.step||1)}" ${pending||!bounds||!bounds.canPurchase||item.quantity+(bounds?.step||1)>bounds.max?'disabled':''} aria-label="${esc(t('increase'))}: ${esc(item.product_title)}">+</button></div>
          <span class="in-cart-item-price">${esc(money(item.final_line_price/100))}</span>
          <button class="in-cart-remove" type="button" data-in-cart-key="${esc(item.key)}" data-in-cart-qty="0" ${disabled} aria-label="${esc(t('remove'))}: ${esc(item.product_title)}">${removeIcon}</button>
        </div>
      </div>
    </article>`;}).join('');
    return `<div class="in-cart-shell">${cartHeaderHtml(cart.item_count,mode==='checking'?cartText('checking'):'')}<div class="in-cart-items" data-in-cart-scroll>${message?cartFailureHtml(message):''}${cart.item_count?lines:`<div class="empty-bag"><span aria-hidden="true">◇</span><p>${esc(t('empty_bag'))}</p><a class="in-cart-checkout" href="${esc(config.catalog)}">${esc(t('browse_all'))}</a></div>`}</div>${cart.item_count?`<footer class="in-cart-footer">${cartShippingProgress(cart)}<div class="in-cart-total"><span>${esc(t('subtotal'))}</span><strong>${esc(money(cart.total_price/100))}</strong></div><form action="${esc(config.cart)}" method="post"><button class="in-cart-checkout" name="checkout" type="submit" value="checkout" ${pending||needsAdjustment?'disabled':''}><span>${esc(t('checkout'))}</span></button></form></footer>`:''}</div>`;
  }
  async function changeCartQuantity(target){
    if(cartBusy||target.disabled)return;
    cartBusy=true;
    const owner=cartViewRequests.version,host=modal;
    const current=()=>owner===cartViewRequests.version&&host===modal&&modal.open&&modal.classList.contains('drawer')&&!window.IdolnestDrawerMotion?.isClosing(modal);
    let finishMutation;
    const mutation=new Promise(resolve=>finishMutation=resolve);cartMutationPending=mutation;
    const key=target.dataset.inCartKey,quantity=Number(target.dataset.inCartQty),list=$('[data-in-cart-scroll]'),scrollTop=list?.scrollTop||0;
    const position=Array.from(document.querySelectorAll('[data-in-cart-line]')).findIndex(line=>line.dataset.inCartLine===key);
    const action=target.classList.contains('in-cart-remove')?'remove':target.textContent.trim()==='+'?'increase':'decrease';
    modal.setAttribute('aria-busy','true');
    const status=modal.querySelector('[data-in-cart-status]');if(status)status.textContent=cartText('updating');
    modal.querySelectorAll('[data-in-cart-key],.in-cart-checkout').forEach(button=>button.disabled=true);
    try{
      const before=await fetchCart();
      const line=before.items.find(item=>item.key===key);
      if(!line)throw new Error(t('error'));
      if(quantity>line.quantity){
        const fresh=await readInventory(line.url);
        applyInventory(fresh);
        const bounds=cartLineBounds(line);
        if(!bounds||quantity>bounds.max)throw new Error(quantityMessage(Math.max(0,(bounds?.max||0)-line.quantity)));
      }
      const cart=await request('cart/change.js',{id:key,quantity});
      if(!current()){updateCart(cart);return;}
      if(!openCart(cart,false))return;
      const newList=$('[data-in-cart-scroll]');if(newList)newList.scrollTop=scrollTop;
      const rows=Array.from(document.querySelectorAll('[data-in-cart-line]'));
      const row=rows.find(line=>line.dataset.inCartLine===key)||rows[Math.min(position,rows.length-1)];
      const focusTarget=action==='remove'?row?.querySelector('.in-cart-remove'):row?.querySelector(`.in-cart-quantity button:${action==='increase'?'last':'first'}-child`);
      (focusTarget||modal.querySelector('[data-in-close-modal]'))?.focus({preventScroll:true});
      const updated=modal.querySelector('[data-in-cart-status]');if(updated)updated.textContent=cartText('updated');
    }catch(error){
      try{const cart=await fetchCart();if(current()){openModal(cartHtml(cart,'error',error.message),'drawer');modal.dataset.inCartState='error';}}catch{if(current()){openModal(cartLoadingHtml(cartText('error')),'drawer');modal.dataset.inCartState='error';}}
    }finally{cartBusy=false;finishMutation();if(cartMutationPending===mutation)cartMutationPending=null;if(current())modal.removeAttribute('aria-busy');}
  }
  async function showCart(focusTitle=false){
    bindModal();
    const other=document.querySelector('dialog[open]');
    if(!modal||(other&&other!==modal)||(modal.open&&!modal.classList.contains('drawer')))return false;
    const host=modal,ticket=cartViewRequests.begin();let cart=null;
    const current=()=>cartViewRequests.current(ticket)&&host===modal&&host.isConnected&&host.open&&host.classList.contains('drawer')&&!window.IdolnestDrawerMotion?.isClosing(host);
    const keepTitleFocus=()=>focusTitle&&document.activeElement===host.querySelector('#InCartTitle');
    const focusHeading=()=>{const title=host.querySelector('#InCartTitle');if(title){title.tabIndex=-1;title.focus({preventScroll:true});}};
    openModal(cartLoadingHtml(),'drawer');host.dataset.inCartState='loading';host.setAttribute('aria-busy','true');
    if(focusTitle)focusHeading();
    try{
      if(cartMutationPending)await cartMutationPending;
      if(!current())return false;
      cart=await request('cart.js',undefined,{signal:ticket.signal});
      if(!current())return false;
      const focusChecking=keepTitleFocus();
      openModal(cartHtml(cart,'checking'),'drawer');host.dataset.inCartState='checking';
      if(focusChecking)focusHeading();
      await refreshCartInventory(cart,{signal:ticket.signal,current});
      if(!current())return false;
      const focusReady=keepTitleFocus();
      openCart(cart,false);
      if(focusReady)focusHeading();
      return true;
    }catch(error){
      if(!current())return false;
      const focusError=keepTitleFocus();
      openModal(cart?cartHtml(cart,'error',cartText('verification_error')):cartLoadingHtml(error.name==='AbortError'?cartText('timeout'):cartText('error')),'drawer');
      host.dataset.inCartState='error';host.removeAttribute('aria-busy');
      if(focusError)focusHeading();
      return false;
    }
  }
  function showSearch(){if(modal?.open)closeModal(true);const search=document.querySelector('idolnest-search');if(typeof search?.open==='function')search.open();else location.href=config.search;}
  function initProduct(root){
    if(productInstances.has(root))return;
    const productForm=root.querySelector('.in-product-form');
    const productNode=root.querySelector('[data-in-product-json]');
    const selector=root.querySelector('[data-in-variant]');
    if(!productForm||!productNode||!selector)return;
    let productData;
    try{productData=JSON.parse(productNode.textContent);}catch{return;}
    if(!Array.isArray(productData.variants))return;
    const controller=new AbortController();
    const listenerOptions={signal:controller.signal};
    const variantPicker=productForm.querySelector('[data-in-variant-picker]');
    const quantity=productForm.elements.quantity;
    const stockStatus=root.querySelector('[data-in-status]');
    const status=root.querySelector('[data-in-form-status]');
    let submitting=false,refreshing=null;
    let initial;
    try{initial=JSON.parse(root.querySelector('[data-in-inventory-initial]')?.textContent||'null');}catch{}
    if(initial?.cartItems)setCartQuantities(initial.cartItems);
    for(const variant of productData.variants)inventoryByVariant.set(String(variant.id),variant);
    const selectedVariant=()=>productData.variants.find(variant=>String(variant.id)===selector.value);
    const active=()=>root.isConnected&&productInstances.get(root)===instance;
    const boundsFor=(selected=selectedVariant())=>quantityBounds(selected,cartQuantities.get(String(selected?.id))||0);
    function syncVariantPicker(selected=selectedVariant()){
      if(!variantPicker)return;
      variantPicker.querySelectorAll('[data-in-variant-choice]').forEach(radio=>{
        const variant=productData.variants.find(item=>String(item.id)===radio.value);
        const label=radio.nextElementSibling;
        radio.checked=radio.value===String(selected?.id);
        const available=quantityBounds(variant).canPurchase;
        radio.disabled=submitting;
        label.classList.toggle('is-unavailable',!available);
        label.querySelector('.in-variant-option-state').hidden=available;
        if(radio.checked)variantPicker.querySelector('[data-in-selected-variant]').textContent=radio.dataset.variantTitle;
      });
    }
    function updateButtons(selected=selectedVariant()){
      const bounds=boundsFor(selected),available=quantityBounds(selected).canPurchase;
      root.querySelectorAll('[data-in-add],[data-in-sticky-add]').forEach(button=>{
        button.disabled=submitting||!bounds.canPurchase;
        button.textContent=bounds.canPurchase?t('add_to_cart'):available?t('limit_reached'):t('sold_out');
      });
      const checkout=productForm.querySelector('.in-dynamic-checkout');
      if(checkout)checkout.hidden=submitting||!bounds.canPurchase;
    }
    function updateQuantity(){
      const bounds=boundsFor();
      quantity.min=bounds.min;
      quantity.step=bounds.step;
      if(Number.isFinite(bounds.max))quantity.max=bounds.max;else quantity.removeAttribute('max');
      quantity.value=boundedQuantity(quantity.value,bounds);
      quantity.disabled=!bounds.canPurchase;
      quantity.readOnly=submitting;
      root.querySelectorAll('[data-in-quantity-step]').forEach(button=>{
        const direction=Number(button.dataset.inQuantityStep);
        button.disabled=submitting||!bounds.canPurchase||(direction<0?Number(quantity.value)<=bounds.min:Number(quantity.value)+bounds.step>bounds.max);
      });
      updateButtons();
    }
    async function refreshInventory(force=false){
      if(refreshing){if(!force)return refreshing;await refreshing.catch(()=>{});}
      const work=async()=>{
        const revision=cartRevision;
        const fresh=await readInventory(productData.url);
        if(String(fresh.id)!==String(productData.id))throw new Error(t('stock_check_failed'));
        if(!active())return fresh;
        applyInventory(fresh);
        if(!cartBusy&&revision===cartRevision)setCartQuantities(fresh.cartItems);
        stockStatus.dataset.stockUpdatedAt=String(Date.now());
        return fresh;
      };
      refreshing=work();
      try{return await refreshing;}finally{refreshing=null;}
    }
    function updateVariant(){
      const selected=selectedVariant();
      if(!selected)return;
      syncProductPrice(root,selected);
      updateQuantity();
      status.textContent='';
      if(selected.mediaId)root.querySelector('[data-in-gallery]')?.dispatchEvent(new CustomEvent('idolnest:media-select',{detail:{id:selected.mediaId}}));
      const url=new URL(location.href);
      url.searchParams.set('variant',selected.id);
      history.replaceState({},'',url);
      syncVariantPicker(selected);
      refreshInventory().catch(()=>{});
    }
    const instance={
      root,
      form:productForm,
      data:productData,
      updateQuantity,
      changeQuantity(direction){
        const bounds=boundsFor();
        quantity.value=boundedQuantity(Number(quantity.value)+Number(direction)*bounds.step,bounds);
        updateQuantity();
      },
      updateInventory(detail){
        if(String(detail.productId)!==String(productData.id))return;
        const latest=new Map(detail.variants.map(variant=>[String(variant.id),variant]));
        productData.variants.forEach(variant=>{const fresh=latest.get(String(variant.id));if(fresh)Object.assign(variant,fresh);});
        updateQuantity();
        syncVariantPicker();
      },
      cleanup(){controller.abort();clearInterval(timer);delete root.dataset.inProductReady;}
    };
    productInstances.set(root,instance);
    if(variantPicker){
      syncVariantPicker();
      productForm.querySelector('[data-in-variant-fallback]').hidden=true;
      variantPicker.hidden=false;
      variantPicker.addEventListener('change',event=>{
        if(!event.target.matches('[data-in-variant-choice]'))return;
        selector.value=event.target.value;
        selector.dispatchEvent(new Event('change',{bubbles:true}));
      },listenerOptions);
    }
    quantity.addEventListener('input',()=>{if(quantity.value!=='')updateQuantity();},listenerOptions);
    quantity.addEventListener('change',updateQuantity,listenerOptions);
    selector.addEventListener('change',updateVariant,listenerOptions);
    productForm.addEventListener('submit',async event=>{
      event.preventDefault();
      if(submitting||cartBusy)return;
      updateQuantity();
      if(!boundsFor().canPurchase||!productForm.reportValidity())return;
      const requested=Number(quantity.value),variantId=selector.value;
      submitting=true;
      cartBusy=true;
      updateQuantity();
      syncVariantPicker();
      status.textContent='';
      try{
        const fresh=await refreshInventory(true);
        if(!active())return;
        setCartQuantities(fresh.cartItems);
        if(selector.value!==variantId)throw new Error(t('error'));
        const bounds=boundsFor();
        if(!bounds.canPurchase||requested>bounds.max)throw new Error(quantityMessage(bounds.max));
        quantity.value=boundedQuantity(requested,bounds);
        await request('cart/add.js',new FormData(productForm));
        if(!active())return;
        status.textContent=t('added_to_cart');
        await showCart();
      }catch(error){
        if(active()){status.textContent=error.message;notify(error.message);await fetchCart().catch(()=>{});}
      }finally{
        submitting=false;
        cartBusy=false;
        if(active()){updateQuantity();syncVariantPicker();}
      }
    },listenerOptions);
    const refreshVisible=()=>{if(!document.hidden&&active())refreshInventory().catch(()=>{});};
    document.addEventListener('visibilitychange',refreshVisible,listenerOptions);
    document.addEventListener('idolnest:inventory:refresh',refreshVisible,listenerOptions);
    window.addEventListener('focus',refreshVisible,listenerOptions);
    window.addEventListener('pageshow',refreshVisible,listenerOptions);
    const timer=setInterval(refreshVisible,Math.max(15,Number(stockStatus?.dataset.stockRefresh)||15)*1000);
    updateQuantity();
    root.dataset.inProductReady='true';
  }
  function initProducts(scope=document){
    for(const [root,instance] of productInstances){
      if(!root.isConnected){instance.cleanup();productInstances.delete(root);}
    }
    if(scope.matches?.('[data-in-product]'))initProduct(scope);
    scope.querySelectorAll('[data-in-product]').forEach(initProduct);
  }
  initProducts();
  document.addEventListener('shopify:section:load',event=>{
    initProducts(event.target);
    if(event.target.querySelector('#InModal')){
      const wasOpen=modal?.open&&modal.classList.contains('drawer');
      bindModal();
      if(wasOpen)showCart();else if(!modal?.open)document.body.style.overflow='';
    }
  });
  document.addEventListener('shopify:section:select',event=>{if(event.target.querySelector('#in-free-shipping-config'))showCart();});
  document.addEventListener('shopify:section:unload',event=>{
    for(const [root,instance] of productInstances){
      if(root===event.target||event.target.contains(root)){instance.cleanup();productInstances.delete(root);}
    }
  });
  document.addEventListener('idolnest:inventory:updated',event=>{
    for(const instance of productInstances.values())instance.updateInventory(event.detail);
  });
  async function addCardProduct(event){
    const form=event.target;
    if(!form.matches?.('form[data-in-card-add]'))return;
    event.preventDefault();
    const button=form.querySelector('button[type="submit"]');
    const status=form.closest('article')?.querySelector('[data-in-card-status]');
    if(!button||form.dataset.inCardPending==='true')return;
    if(cartBusy){if(status)status.textContent=cartText('updating');return;}
    if(button.disabled||!form.reportValidity())return;
    const wasDisabled=button.disabled;
    form.dataset.inCardPending='true';
    form.setAttribute('aria-busy','true');
    button.disabled=true;
    cartBusy=true;
    if(status)status.textContent=cartText('updating');
    try{
      await request('cart/add.js',new FormData(form));
      if(!form.isConnected){await fetchCart().catch(()=>{});return;}
      if(status)status.textContent=t('added_to_cart');
      await showCart();
    }catch(error){
      if(form.isConnected){if(status)status.textContent=error.message||t('error');else notify(error.message||t('error'));}
      await fetchCart().catch(()=>{});
    }finally{
      cartBusy=false;
      delete form.dataset.inCardPending;
      form.removeAttribute('aria-busy');
      button.disabled=wasDisabled;
    }
  }
  document.addEventListener('submit',addCardProduct);
  const filterDialog=$('#InFilterDialog');if(filterDialog)filterDialog.addEventListener('close',()=>document.body.style.overflow='');
  const sort=$('[data-in-sort]');if(sort)sort.addEventListener('change',()=>sort.form.requestSubmit());
  document.addEventListener('click',async e=>{const target=e.target.closest('button,a');if(!target)return;
    if(target.hasAttribute('data-in-close-modal')){closeModal();return;}
    if(target.hasAttribute('data-in-cart-retry')){await showCart(true);return;}
    const product=productInstances.get(target.closest('[data-in-product]'));
    if(target.dataset.inQuantityStep){product?.changeQuantity(target.dataset.inQuantityStep);return;}
    if(target.hasAttribute('data-in-sticky-add')){if(product)product.form.requestSubmit(product.root.querySelector('[data-in-add]'));return;}
    if(target.hasAttribute('data-in-share')){if(!product)return;try{await navigator.clipboard.writeText(config.origin+product.data.url);notify(t('copied'));}catch{openModal(`<h2>${esc(t('share'))}</h2><input class="search-input" value="${esc(config.origin+product.data.url)}" readonly aria-label="${esc(t('copy_link'))}">`,'narrow');}return;}
    if(target.hasAttribute('data-in-open-filters')){filterDialog.showModal();document.body.style.overflow='hidden';return;}
    if(target.hasAttribute('data-in-close-filters')){filterDialog.close();return;}
    if(target.dataset.inCartKey){await changeCartQuantity(target);return;}
    if(target.dataset.newsletter){openModal($('#idolnest-newsletter-template').innerHTML,'narrow');const tags=$('#InModalContent input[name="contact[tags]"]');if(tags)tags.value='newsletter,'+target.dataset.newsletter;return;}
    if(target.dataset.policy){const url=target.dataset.policy==='privacy'?config.privacy:config.terms;if(url)location.href=url;return;}
    switch(target.dataset.action){case 'search':showSearch();break;case 'cart':await showCart();break;case 'account':location.href=config.account;break;case 'region':openModal($('#idolnest-region-template').innerHTML,'narrow');break;case 'menu':{const drawer=document.querySelector('idolnest-navigation');if(typeof drawer?.toggle==='function'){if(modal?.open)closeModal(true);drawer.toggle();}else{const nav=$('#main-nav'),open=nav.classList.toggle('open');target.setAttribute('aria-expanded',open);}break;}}
  });
  $('#main-nav').addEventListener('click',e=>{if(e.target.closest('a')){$('#main-nav').classList.remove('open');$('.mobile-toggle').setAttribute('aria-expanded','false');}});
  document.addEventListener('keydown',e=>{if(e.key==='Escape'){$('#main-nav').classList.remove('open');$('.mobile-toggle').setAttribute('aria-expanded','false');}});
  if($('[data-in-cart-page]')&&!window.Shopify?.designMode&&new URL(location.href).searchParams.get('cart_view')!=='page')showCart(true);else fetchCart().catch(()=>{});
})();
